import React from "react";
import { Layout, Typography } from "antd";
import { useLayoutShell } from "./LayoutShellContext";

const { Header, Content } = Layout;

/** 顶栏默认标题（与业务口径一致时可由路由传入覆盖） */
export const APP_DEFAULT_TITLE = "门店运营信息";

export interface AppTitleLayoutProps {
  /** 顶栏左侧标题 */
  title?: string;
  children: React.ReactNode;
}

/**
 * 应用壳：顶栏左侧标题 + Context 注册的右侧区域；主内容区 16px 内边距并撑满剩余高度。
 */
export const AppTitleLayout: React.FC<AppTitleLayoutProps> = ({
  title = APP_DEFAULT_TITLE,
  children,
}) => {
  const { headerRight, headerLeft } = useLayoutShell();

  return (
    <Layout
      style={{
        margin: 0,
        padding: 0,
        width: "100%",
        flex: 1,
        minHeight: 0,
        maxHeight: "100%",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Header
        style={{
          flexShrink: 0,
          height: 56,
          lineHeight: "56px",
          padding: "0 16px",
          margin: 0,
          background: "#fff",
          borderBottom: "1px solid #f0f0f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <div
          style={{
            flex: 1,
            minWidth: 0,
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          {headerLeft ?? (
            <Typography.Title
              level={5}
              style={{ margin: 0, fontWeight: 600, flexShrink: 0 }}
            >
              {title}
            </Typography.Title>
          )}
        </div>
        {headerRight ? (
          <div style={{ flexShrink: 0, marginLeft: "auto" }}>{headerRight}</div>
        ) : null}
      </Header>
      <Content
        style={{
          margin: 0,
          padding: 16,
          flex: 1,
          minHeight: 0,
          background: "#fff",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flex: 1,
            minHeight: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {children}
        </div>
      </Content>
    </Layout>
  );
};
